module.exports = __webpack_public_path__ + "img/dropsLive-promotion.8f9aa319.png";